import React, { useCallback, useEffect, useState } from 'react';
import Card from 'components/Card';
import Button from 'components/common/buttons/Button';
import { DataForm, Input } from 'components/formik_inputs';
import {
  createDiscipline,
  editDisciplines,
  deleteDiscipline,
} from '../../services/academic';
import { toast } from 'react-toastify';
import { useHistory, useParams } from 'react-router-dom';
import { getDiscipline } from '../../services/academic';
import { nativeGet as get } from 'utils';
import { PermissionContext } from 'hoc/withPermission';
import ButtonWithConfirmation from 'components/common/buttons/ButtonWithConfirmation';

const DisciplineFormPage = ({ ...props }) => {
  const { id } = useParams();
  const history = useHistory();
  const edit = window.location.pathname.includes('edit');
  const [initialData, setInitialData] = useState(false);

  useEffect(() => {
    if (edit && !initialData) {
      getDiscipline(id).then(setInitialData);
    }
  }, []);

  const submit = async (data) => {
    if (edit) {
      return editDisciplines(id, data).then((res) => {
        toast.success('Disciplina editada com sucesso.');
        history.push('/disciplinas');
      });
    } else {
      return createDiscipline(data).then((res) => {
        toast.success('Disciplina criada com sucesso.');
        history.push('/disciplinas');
      });
    }
  };

  const handleDelete = useCallback(async () => {
    try {
      await deleteDiscipline(id);

      toast.success('Disciplina excluída com sucesso.');
      history.push('/disciplinas');
    } catch (err) {
      const error = get(err, 'response.data.detail', '');
      toast.error(error || 'Ocorreu um erro ao remover a Disciplina.');
    }
  }, [id]);

  return (
    <Card title={id ? 'Editar Disciplina' : 'Adicionar Disciplina'}>
      <DataForm
        autoSetErrors
        initialValues={initialData || { nome: '' }}
        onSubmit={submit}
        enableReinitialize
      >
        <>
          <Input type="text" name="nome" placeholder="Nome da disciplina" />
          <div
            style={{
              width: '100%',
              height: 'auto',
              display: 'flex',
              justifyContent: 'space-between',
              paddingTop: '20px',
            }}
          >
            <Button onClick={() => history.push('/disciplinas')} type="button">
              Voltar
            </Button>
            <div>
              <PermissionContext.Consumer>
                {({ hasPermission }) =>
                  hasPermission('academico.delete_disciplina') &&
                  edit && (
                    <ButtonWithConfirmation
                      action="danger"
                      confirmationText="Deseja excluir permanentemente essa Disciplina ?"
                      onClick={handleDelete}
                    >
                      Excluir
                    </ButtonWithConfirmation>
                  )
                }
              </PermissionContext.Consumer>
              <Button type="submit">Salvar</Button>
            </div>
          </div>
        </>
      </DataForm>
    </Card>
  );
};

export default DisciplineFormPage;
